import { element as el } from '../dom.js';
import type { createAccountService } from '../../authentication/account-service.js';
export function showAccountError(error: unknown) {
  const code = (error as { code?: string }).code;
  const messages: Record<string, string> = {
    'auth/invalid-credential': 'Email or password is incorrect.',
    'auth/email-already-in-use': 'This email already has an account. Sign in instead.',
    'auth/operation-not-allowed': 'This sign-in method is not enabled in Firebase. Try Google or enable Email/Password in the Firebase console.',
    'auth/unauthorized-domain': 'Add this website domain to Firebase Authentication → Settings → Authorized domains.',
    'auth/popup-blocked': 'Allow the Google sign-in popup in your browser.',
    'auth/network-request-failed': 'Cannot reach Firebase Auth. Check your connection or start the local auth emulator.',
    'auth/weak-password': 'Choose a password of at least 6 characters.',
    'auth/too-many-requests': 'Too many sign-in attempts. Please try again later.',
  };
  el('lobby-error').textContent = messages[code || ''] || (error as Error).message || 'Sign-in failed.';
}

export function bindAccountPanel(accounts: Awaited<ReturnType<typeof createAccountService>>, leave: () => void) {
  let busy = false;
  async function authAction(action: () => Promise<unknown>) {
    if (busy) return; busy = true; el('lobby-error').textContent = '';
    el('auth-panel').querySelectorAll<HTMLButtonElement>('button').forEach(button => { button.disabled = true; });
    try { await action(); } catch (error) { showAccountError(error); }
    finally { busy = false; el('auth-panel').querySelectorAll<HTMLButtonElement>('button').forEach(button => { button.disabled = false; }); }
  }
  if (accounts.emulator) {
    el('google').hidden = true;
    const panel = document.createElement('section'); panel.className = 'test-account-panel';
    const heading = document.createElement('strong'); heading.textContent = 'Local test players';
    const hint = document.createElement('p'); hint.className = 'hint';
    hint.textContent = 'No real Google or Firebase login needed. Choose a different player in each browser tab.';
    panel.append(heading, hint);
    for (const slot of [1, 2] as const) {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'secondary'; button.textContent = `Use Test Player ${slot}`;
      button.addEventListener('click', () => void authAction(async () => { const player = await accounts.testPlayer(slot); el('account').textContent = player.displayName || `Test Player ${slot}`; })); panel.append(button);
    }
    el('auth-panel').prepend(panel);
    (el('auth-panel').querySelector('.divider') as HTMLElement).hidden = true;
    const extra = document.createElement('details'); extra.className = 'test-account-details';
    const summary = document.createElement('summary'); summary.textContent = 'Use another fake account';
    extra.append(summary, el('auth-form')); el('auth-panel').append(extra);
    extra.addEventListener('toggle', () => el('lobby').classList.toggle('test-account-expanded', extra.open));
    el('auth-form').querySelectorAll('label').forEach((label, index) => { label.firstChild!.textContent = index ? 'Test password' : 'Test email'; });
    el<HTMLInputElement>('email').placeholder = 'player@example.test';
    el<HTMLInputElement>('email').autocomplete = 'off'; el<HTMLInputElement>('password').autocomplete = 'off';
    el('register').textContent = 'Create test account';
    el('auth-form').querySelector('button[type="submit"]')!.textContent = 'Sign in to test account';
  }
  el('google').addEventListener('click', () => void authAction(() => accounts.google()));
  el('auth-form').addEventListener('submit', event => {
    event.preventDefault(); void authAction(() => accounts.email(el<HTMLInputElement>('email').value.trim(), el<HTMLInputElement>('password').value));
  });
  el('register').addEventListener('click', () => {
    if (!el<HTMLFormElement>('auth-form').reportValidity()) return;
    void authAction(async () => {
      const email = el<HTMLInputElement>('email').value.trim();
      const registered = await accounts.register(email, el<HTMLInputElement>('password').value);
      el('account').textContent = registered.displayName;
    });
  });
  el('signout').addEventListener('click', async () => { leave(); try { await accounts.signOut(); } catch (error) { showAccountError(error); } });

}
